import { useRedirectPageHelper } from "../utilies/utilies";
import { useState } from "react";
import { Carousel } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "../static/css/cards.css"


function Cards({images,alt,text,className, price, context, redirectPath, redirectContext, onclick, discount}) {
    const redirectPageHelper = useRedirectPageHelper();
    const [currentIndex, setCurrentIndex] = useState(0);

    const nextImage = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    };
 
    const prevImage = () => {
        setCurrentIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
    };
    if (!className){
    return (
    <div className={"card card-custom col-9 col-sm-3 px-0"}>
        <div className="container p-0" style={{width: "100%", overflow: "hidden"}}>
            <img src={images[0]} className={`card-img-custom-${context}`} alt={alt}></img>
        </div>
        <div className="card-body d-flex flex-column" style={{textAlign: "center"}}>
            <h3 className="card-title">{text}</h3>
            <button onClick={() => redirectPageHelper(redirectPath, { category: redirectContext })} className="btn card-button border-dark p-3">Learn More</button>
        </div>
    </div>
    );} else {
        const realPrice = Number(price);
        const undiscountedPrice = realPrice * (1 + discount/100);
        if(price) {
            return (
                <div className={className}>
                    <div className="container p-0" style={{width: "100%", overflow: "hidden"}}>
                        {images.length === 1 ? (
                            <img src={images[0]} className={`card-img-custom-${context}`} alt={alt} onClick={onclick}/>
                        ) : (
                            <Carousel controls={true} indicators={true} interval={null} className="custom-carousel">
                                {images.map((img, index) => (
                                    <Carousel.Item key={index}>
                                        <img src={img} className={`card-img-custom-${context}`} alt={`${alt}-${index}`} onClick={onclick}/>
                                    </Carousel.Item>
                                ))}
                            </Carousel>
                        )}
                    </div>
                    <div className="card-body d-flex flex-column" style={{textAlign: "center"}}>
                        <h3 className="card-title" style={{fontSize: "clamp(0.2rem, 4vw, 2rem)"}}>{text}</h3>
                        {discount > 0 ? (
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <h4 style={{ textDecoration: "line-through", marginRight: "8px" }}>${undiscountedPrice.toFixed(2)}</h4>
                            <h4>${realPrice.toFixed(2)}</h4>
                        </div>
                        ) : (
                            <span>${realPrice.toFixed(2)}</span>
                        )}
                    </div>
                </div>);
        }
        
    }

}
export default Cards;